module.exports = __webpack_public_path__ + "static/media/burger-open.70f9ee5f.svg";